import { AxiosPromise } from 'axios';
import { IGetInquiry, IGetInquiries } from '../models/boardCommunication.model';
import axios from 'axios';

const uri = '/mgmt/board/communication';

export const getInquiry = (communicationCode: number): AxiosPromise<IGetInquiry> => {
  return axios.get(`${uri}/${communicationCode}`);
}

export const getInquiries = (): AxiosPromise<IGetInquiries> => {
  return axios.get(uri);
}

export const createInquiry = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateInquiry = (communicationCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${communicationCode}`, data);
};

export const createAnswer = (communicationCode: number, data: FormData): AxiosPromise => {
  return axios.post(`${uri}/answer/${communicationCode}`, data);
};

export const updateAnswer = (communicationCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/answer/${communicationCode}`, data);
};
